import { Maybe, toFailure, toSuccess, Try } from '../types/commonTypes'
import { createAxios } from './axios'
import {
  GetMessagingParams,
  GetMessagingResponse,
  RawMessage,
  SendChatMessageParams,
  SendChatMessageResponse,
} from './messagingTypes'
import { TEST_USER_AUTHORIZATION } from './userApiService'

export async function getMessaging({
  authorization = TEST_USER_AUTHORIZATION,
  gameId,
}: GetMessagingParams): Promise<Try<GetMessagingResponse>> {
  try {
    const response = await createAxios(authorization).get<GetMessagingResponse>(`/games/${gameId}/init_messaging.json`)

    const { data } = response

    return toSuccess(data)
  } catch (e: any) {
    return toFailure(e)
  }
}

export async function sendChatMessage({
  authorization = TEST_USER_AUTHORIZATION,
  gameId,
  message,
  to,
}: SendChatMessageParams): Promise<Try<Maybe<RawMessage>>> {
  try {
    const response = await createAxios(authorization).post<SendChatMessageResponse>(`/games/${gameId}/message.json`, {
      message,
      to,
      cc: false, // RFU, statically false on purpose for now
    })

    const { data } = response

    return toSuccess(data.chat_update)
  } catch (e: any) {
    return toFailure(e)
  }
}

//TODO: To send a message
// POST REQUEST TO https://stage.seppo.io/games/<gameId>/message.json
/* payload for general/shoutbox
message: <The message>
to: 
cc: false
*/
/* payload for private message to person with id 10841
message: Hi, JaniP
to: 10841
cc: false
*/
//NOTE: The field cc means that (if true) the message would be echoed to other instructors also, so that they see what other instructor aswered to someone
//      Can be statically false for now
/* Response will be a Message inside chat_updatelike this. Note that you should just ingnore the reply for now. It does not contain valid to/from values. 
   We should consider making a change in the BE that the reply would be valid content.
   For now, to echo the real sent message to UI, you need to wait to get it via the websocket (This is how it's currently in legacy production)
{
    "chat_update": {
        "text": "Hi, JaniP",
        "from": null,
        "to": null,
        "type": null,
        "id": 18510,
        "info": "private-message",
        "tmp_id": null,
        "created_at": "2023-10-20T13:16:15.199Z",
        "msg_type": null,
        "points": null,
        "max_points": null,
        "subtype": null,
        "exercise_id": null,
        "exercise_name": null,
        "is_read": null
    }
}
*/
